/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PatchPlayerPosition = {
    properties: {
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
    },
} as const;
